import React from "react";
import "./WhyChooseAikyam.css";
//import gymImage from "../assets/why-choose.jpg";
import whych1 from "../assets/whych11.jpeg";
import { FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom"; // ✅ Import Link
import { Helmet } from "react-helmet-async";

const WhyChooseAikyam = () => {
  return (
    <>
      <Helmet>
        <title>
          Aikyam Sports Science | Physiotherapy |Sports Performance, Athlete Monitoring &
          Fitness
        </title>

        <meta
          name="description"
          content="Aikyam Sports Science provides athlete performance analysis, timing gate technology, injury prevention, fitness training, sports science solutions, and athlete monitoring systems."
        />

        <meta
          name="keywords"
          content="Aikyam Sports Science, sports science, athlete monitoring, timing gate, fitness training, sports performance, injury prevention, strength and conditioning, Udupi"
        />

        <meta
          property="og:title"
          content="Aikyam Sports Science | Physiotherapy | Train Smarter. Perform Better."
        />

        <meta
          property="og:description"
          content="Sports science solutions for athletes, coaches, academies and sports organizations."
        />

        <meta
          property="og:image"
          content="https://aikyamsports.com/logo11.png"
        />

        <meta property="og:type" content="website" />

        <link
          rel="canonical"
          href="https://aikyamsports.com/booking"
        />
      </Helmet>
    <div className="why-section">
<div className="why-left">
  <img
    src={whych1}
    alt="Professional fitness training session at Aikyam Sports Science"
    onError={(e) => {
      e.currentTarget.onerror = null;
      e.currentTarget.src =
        "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=1200&q=80";
    }}
  />
</div>
      <div className="why-right">
         <div className="why-right1">
        <h2>Why Choose Aikyam?</h2>
        <p className="why-subtext">
          Discover the Benefits That Set Us Apart and Propel Your Fitness Journey Forward.
        </p>
        </div>

        <div className="why-point">
          <FaCheckCircle className="why-icon" />
          <div>
            <h4>Expert Trainers</h4>
            <p>
              Our qualified trainers provide personalized guidance and expert advice to help you achieve your fitness goals.
            </p>
          </div>
        </div>

        <div className="why-point">
          <FaCheckCircle className="why-icon" />
          <div>
            <h4>State-of-the-Art Equipment</h4>
            <p>
              Work out with the latest and most advanced fitness equipment to maximize your results and enhance your experience.
            </p>
          </div>
        </div>

        <div className="why-point">
          <FaCheckCircle className="why-icon" />
          <div>
            <h4>Comprehensive Programs</h4>
            <p>
              Enjoy a variety of classes and programs tailored to all fitness levels, from beginner to advanced.
            </p>
          </div>
        </div>

<Link to="/booking" className="link-no-underline">
  <button className="why-button">
    <img src="/SVG/Consultation.svg" alt="" className="button-icon" />
    Book a consultation
  </button>
</Link>

      </div>
    </div>
    </>
  );
};

export default WhyChooseAikyam;
